/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_ContextInputs */

const en_wb_support_context = /** @type {(inputs: Wb_Support_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer enquiry`)
};

const lv_wb_support_context = /** @type {(inputs: Wb_Support_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienta jautājums`)
};

/**
* | output |
* | --- |
* | "Customer enquiry" |
*
* @param {Wb_Support_ContextInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_context = /** @type {((inputs?: Wb_Support_ContextInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_ContextInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_context(inputs)
	return en_wb_support_context(inputs)
});